export default __webpack_public_path__ + "static/media/tabs-arrow.1aaaeb43.svg";